import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSuperMethod from "vue-super-call";

import VueCookies from "vue-cookies";
import VuejsDialog from "vuejs-dialog";
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;

// Configuration VueAnalytics

Vue.use(
  VueGtag,
  {
    config: {
      id: "G-F3BBX0QPEB"
    }
  },
  router
);

Vue.use(
  VueGtag,
  {
    config: {
      id: "AW-1050781183"
    }
  },
  router
);

let global = {
  pageInitiated: null
};

Vue.prototype.$global = global;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Vue.prototype.$super = VueSuperMethod;

import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents, {
  swipeTolerance: 30
});

navigator.serviceWorker.register(`/worker.js`);

Vue.use(VueCookies);

// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.use(VuejsDialog);

window.alert = async function(text) {
  await Vue.dialog.alert(text, {
    okText: "OK",
    html: true
  });
};

window.prompt = async function(tit) {
  let res = await Vue.dialog.prompt(
    {
      title: tit,
      body: ""
    },
    {
      okText: "OK",
      cancelText: "Cancel",
      promptHelp: "",
      html: true,
      animation: "fade"
    }
  );
  return res.data;
};

window.confirm = async function(tit) {
  try {
    let res = await Vue.dialog.confirm(
      {
        title: "",
        body: tit
      },
      {
        okText: "OK",
        cancelText: "Cancel",
        promptHelp: "",
        html: true,
        animation: "fade"
      }
    );

    return res != false;
  } catch (e) {
    return false;
  }
};
